import React, { useEffect, useState } from "react";
import { Card, CardBody, Input, Modal, Container } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ApiCall from "../../Helpers/ApiCall";

// const BASE = "http://localhost/business_community/";
const BASE = "https://qnexus.in/community/";

const BusinessFeed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [activePost, setActivePost] = useState(null);
  const [commentText, setCommentText] = useState("");

  const userId = useSelector(s => s.customer.customer?.user?.id);

  useEffect(() => {
    fetchFeed();
  }, []);

  const fetchFeed = async () => {
    dispatch(loadingTrue());
    try {
      let res = await ApiCall.get("/post/feed.php");

      if (typeof res === "string") {
        res = JSON.parse(res);
      }

      if (res?.success) {
        setList(res.data.list || []);
      }
    } catch (e) {
      console.error("API ERROR 👉", e);
    }
    dispatch(loadingFalse());
  };

  const toggleLike = async (id) => {
    try {
      await ApiCall.post("/post/reaction.php", { post_id: id });
      fetchFeed();
    } catch (e) {
      console.error("LIKE ERROR 👉", e);
    }
  };

  const addComment = async () => {
    if (!commentText.trim() || !activePost) return;

    try {
      const res = await ApiCall.post("/post/comment.php", {
        post_id: activePost.id,
        comment: commentText
      });

      if (res?.success) {
        setCommentText("");

        const updated = await ApiCall.get("/post/feed.php");

        if (updated?.success) {
          setList(updated.data.list || []);

          const refreshedPost = updated.data.list.find(
            p => p.id === activePost.id
          );

          if (refreshedPost) setActivePost(refreshedPost);
        }
      }
    } catch (e) {
      console.error("COMMENT ERROR 👉", e);
    }
  };

  // 🔥 helper function for media rendering
  const renderMedia = (m, idx) => {
    const url = m.media_url || m.url || "";
    const mediaUrl = url.startsWith("http") ? url : BASE + url;

    const isVideo =
      (m.media_type || "").toUpperCase() === "VIDEO" ||
      mediaUrl.match(/\.(mp4|mov|avi|mkv)$/i);

    if (isVideo) {
      return (
        <video
          key={idx}
          controls
          muted
          playsInline
          style={{ width: "100%" }}
        >
          <source src={mediaUrl} type="video/mp4" />
        </video>
      );
    }

    return (
      <img
        key={idx}
        src={mediaUrl}
        alt="post"
        style={{ width: "100%", borderRadius: "10px" }}
      />
    );
  };

  return (
    <div className="biz-feed-page">
      <Container fluid className="py-4 px-lg-5">
        <div className="feed-layout-grid">
          <div className="feed-main-content">
            {list.map(item => {
              const liked = item?.liked_by?.length > 0;

              return (
                <Card key={item.id} className="feed-card">
                  <CardBody className="p-0">

                    {/* HEADER */}
                    <div className="feed-header p-3">
                      <div className="d-flex align-items-center gap-2">
                        <div className="feed-avatar-wrapper">
                          <img
                            src={BASE + item.logo}
                            alt="logo"
                            className="feed-avatar"
                          />
                        </div>
                        <div>
                          <h6 className="feed-business-name mb-0">
                            {item.business_name}
                            {item.is_verified == 1 && (
                              <i className="bx bxs-badge-check" title="Verified" style={{ color: "#2563eb", fontSize: "15px", marginLeft: "5px", verticalAlign: "middle" }} />
                            )}
                          </h6>
                          <span className="feed-timestamp">
                            {item.created_at}
                          </span>
                        </div>
                      </div>

                    </div>

                    {/* CONTENT */}
                    {item.content && (
                      <div className="feed-text-content px-3 pb-3">
                        {item.content}
                      </div>
                    )}

                    {/* MEDIA */}
                    {item.post_type !== "TEXT" && (
                      <div className="feed-media-section mx-3">
                        {item.media && item.media.length > 0 ? (
                          item.media.map((m, idx) => renderMedia(m, idx))
                        ) : (
                          <div className="placeholder-showcase">
                            <span>No Media</span>
                          </div>
                        )}
                      </div>
                    )}

                    {/* ACTIONS */}
                    <div className="feed-action-bar mt-3">
                      <div
                        className={`action-btn ${liked ? "liked" : ""}`}
                        onClick={() => toggleLike(item.id)}
                      >
                        <i className={liked ? "fa-solid fa-heart" : "fa-regular fa-heart"}></i>
                        <span>Like</span>
                      </div>

                      <div
                        className="action-btn"
                        onClick={() => setActivePost(item)}
                      >
                        <i className="fa-regular fa-comment"></i>
                        <span>Comment</span>
                      </div>
                    </div>

                  </CardBody>
                </Card>
              );
            })}
          </div>

          <div className="feed-sidebar-space d-none d-xl-block"></div>
        </div>
      </Container>

      {/* MODAL */}
      {/* MODAL */}
      <Modal
        isOpen={!!activePost}
        toggle={() => setActivePost(null)}
        centered
        size="lg"
        className="biz-hub-modal"
      >
        {activePost && (
          <div className={`feed-view-wrapper ${!activePost.media?.length ? "feed-view-wrapper--no-media" : ""}`}>

            {/* MEDIA — only show if media exists */}
            {activePost.media?.length > 0 && (
              <div className="feed-view-media">
                {renderMedia(activePost.media[0], 0)}
              </div>
            )}

            {/* COMMENTS */}
            <div className="feed-view-comments">
              <div className="modal-comment-header">
                <h6>Comments</h6>
                <button
                  onClick={() => setActivePost(null)}
                  style={{
                    background: "transparent", border: "none",
                    fontSize: "20px", cursor: "pointer",
                    padding: "5px", borderRadius: "50%", transition: "0.2s"
                  }}
                  onMouseEnter={(e) => { e.target.style.backgroundColor = "#f0f0f0"; e.target.style.color = "red"; }}
                  onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#000"; }}
                >
                  ✕
                </button>
              </div>

              <div className="comments-list-container">
                {activePost.comments?.map((c, i) => (
                  <div key={i}>
                    <b>{c.commented_by?.business_name}</b>
                    <p>{c.comment}</p>
                    <small>{moment(c.created_at).fromNow()}</small>
                  </div>
                ))}
              </div>

              <div className="comment-input-area">
                <Input
                  placeholder="Write a comment..."
                  value={commentText}
                  onChange={e => setCommentText(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && addComment()}
                />
                <button
                  onClick={addComment}
                  style={{ backgroundColor: "#2563eb", color: "white", padding: "8px 16px", border: "none", borderRadius: "5px" }}
                >
                  Send
                </button>
              </div>
            </div>

          </div>
        )}
      </Modal>
    </div >
  );
};

export default BusinessFeed;